var _path, _path2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Benefiticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 35C20.6666 28.7146 20.6666 25.5719 22.6192 23.6193C24.5719 21.6667 27.7146 21.6667 34 21.6667C40.2854 21.6667 43.4281 21.6667 45.3807 23.6193C47.3333 25.5719 47.3333 28.7146 47.3333 35C47.3333 41.2854 47.3333 44.4281 45.3807 46.3807C43.4281 48.3334 40.2854 48.3334 34 48.3334C27.7146 48.3334 24.5719 48.3334 22.6192 46.3807C20.6666 44.4281 20.6666 41.2854 20.6666 35Z",
    fill: "#7957FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 28.6667C34.5522 28.6667 35 29.1144 35 29.6667V34.5858L38.0404 37.6262C38.4309 38.0168 38.4309 38.6499 38.0404 39.0405C37.6499 39.431 37.0167 39.431 36.6262 39.0405L33.2929 35.7071C33.1053 35.5196 33 35.2652 33 35V29.6667C33 29.1144 33.4477 28.6667 34 28.6667Z",
    fill: "#05071B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 58,
    height: 58,
    rx: 15.5,
    stroke: "url(#paint0_linear_27_1850)",
    strokeOpacity: 0.3,
    strokeWidth: 11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_1850",
    x1: 34.5,
    y1: 0,
    x2: 34.5,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Benefiticon);
export default __webpack_public_path__ + "static/media/3 benefit icon.36b7bdebe756e5767a9f84978437776a.svg";
export { ForwardRef as ReactComponent };